import { AuthError } from "../types";

export const mapAuthError = (error: AuthError) => {
  if (error.code === "invalid_credentials") {
    return error.message;
  }

  return "Something went wrong";
};
